<template>
  <div class="main_box">
    <div class="cancel_account_head">
      <div class="title">帐号注销说明</div>
    </div>
    <div class="main_body">
      <el-row class="cancel_account_body">
        <el-col
          :xs="{ span: 24, offset: 0 }"
          :sm="{ span: 12, offset: 6 }"
          :md="{ span: 10, offset: 7 }"
          :lg="{ span: 8, offset: 8 }"
          :xl="{ span: 8, offset: 8 }"
        >
          <div class="cancel_account_title">
            <div>
              注销投票云会议帐号是不可恢复的操作。在注销帐号后，您将无法登录使用该帐号。
            </div>
            <div>您在注销帐号前，请确认：</div>
          </div>
          <div class="cancel_account_content">
            <div class="item">1.帐号余额已经清零或得到妥善处理。</div>
            <div class="item">
              2. 您的帐号中所包含的信息已得到妥善保存：包括但不限于投票纪录等。
            </div>
            <div class="item">
              3. 帐号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="cancel_account_foot">
        <el-button type="primary" @click="openPersonal()">
          返回个人中心
        </el-button>
        <br />
        <br />
        <el-link
          type="danger"
          style="color: #ff3c33"
          @click="openCandelAccount()"
          v-if="showCancelAccountBtn"
        >
          注销账号
        </el-link>
        <el-link type="info" v-if="!showCancelAccountBtn" disabled>
          注销账号({{ countdown }})
        </el-link>
      </div>
    </div>
    <el-dialog
      title="注销-身份验证"
      :visible.sync="dialogAccountVerification"
      custom-class="cancelAccount_dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-if="cancelAccountType === 1">
        <div>您正在注销账号，请先完成身份验证。</div>
        <div>验证码会发送至 {{ phone }}</div>
        <br />
        <el-form
          :model="cancelAccountForm"
          :rules="cancelAccountRules"
          ref="cancelAccountForm"
          label-width="0px"
          class="login_box_form"
        >
          <el-form-item label="" prop="VerificationCode">
            <el-input
              type="text"
              v-model="cancelAccountForm.VerificationCode"
              maxlength="4"
              placeholder="验证码"
              style="float: left; width: 70%"
            ></el-input>
            <el-image
              style="float: right; width: 20%; margin-right: 9%; height: 30px"
              :src="imageCode"
              fit="fill"
              @click="getImageCode()"
            >
              <div slot="error" class="image-slot">
                <span>加载中…</span>
              </div>
            </el-image>
          </el-form-item>
          <el-form-item label="" prop="PhoneCode">
            <el-input
              type="text"
              v-model="cancelAccountForm.PhoneCode"
              maxlength="4"
              placeholder="短信验证码"
              style="float: left; width: 70%"
            ></el-input>
            <el-button
              style="float: right; width: 28%; margin-right: 1%"
              v-on:click="sendPhoneCode()"
            >
              获取验证码
            </el-button>
            <span v-if="showPhoneCodeMessage">
              短信验证码已发送，请您在5分钟内填完。
            </span>
          </el-form-item>
          <el-form-item class="from_btn_box">
            <el-button
              @click="dialogAccountVerification = false"
              class="from_btn"
            >
              取 消
            </el-button>
            <el-button
              type="primary"
              class="from_btn"
              v-on:click="submitCancelAccountForm('cancelAccountForm')"
            >
              确 定
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="cancel_code_box" v-if="cancelAccountType === 2">
        <div class="cancel_code">
          <span>您正在注销账号，请使用微信扫描二维码</span>
          <wxlogin
            :theme="'black'"
            :appid="this.$config.wxAppId"
            :scope="this.$config.wxSnsapiLogin"
            :redirect_uri="this.$config.wxCancelAccountRedirectUri"
            :href="wxCustomStyle"
            style="width: 200px; height: 200px; overflow: hidden"
          ></wxlogin>
          <!-- :redirect_uri="this.$config.wxCancelAccountRedirectUri" -->
        </div>
      </div>
      <br />
      <el-divider v-if="cancelAccountType === 1 && userInfo.IsBindWechat">
        其它验证身份方式
      </el-divider>
      <el-divider v-if="cancelAccountType === 2 && userInfo.Phone">
        其它验证身份方式
      </el-divider>
      <div class="more_sign_box">
        <el-button
          size="mini"
          icon="iconfont icon-weixin"
          @click="scanQRCode('wechat')"
          v-if="cancelAccountType === 1 && userInfo.IsBindWechat"
        >
          微信验证
        </el-button>
        <el-button
          size="mini"
          icon="el-icon-lock"
          @click="phoneShortMessage('account')"
          v-if="cancelAccountType === 2 && userInfo.Phone"
        >
          手机短信验证
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wxlogin from 'vue-wxlogin'
export default {
  components: {
    wxlogin
  },
  data () {
    return {
      dialogAccountVerification: false,
      showCancelAccountBtn: false,
      countdown: 15,
      userInfo: {},
      phone: null,
      cancelAccountType: 1,
      cancelAccountForm: {
        PhoneNumber: null,
        PhoneCode: null,
        PhoneEncryptCode: null,
        PhoneEncryptExpireTime: null,
        VerificationCode: null,
        EncryptCode: null,
        EncryptPhoneNumber: null
      },
      cancelAccountRules: {
        VerificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入正确的验证码', trigger: 'blur' }
        ],
        PhoneCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入正确的短信验证码', trigger: 'blur' }
        ]
      },
      imageCode: '',
      verificationPhoneCode: {
        EncryptCode: '',
        InputCode: '',
        PhoneNumber: ''
      },
      showPhoneCodeMessage: false,
      wxCustomStyle: 'data:text/css;base64,LmltcG93ZXJCb3ggewogIHRleHQtYWxpZ246IGxlZnQ7Cn0KLmltcG93ZXJCb3ggLnRpdGxlIHsKICBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgewogIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggLnFyY29kZSB7CiAgbWFyZ2luLXRvcDogMHB4OwogIGJvcmRlcjogbm9uZTsKICB3aWR0aDogMjAwcHg7CiAgaGVpZ2h0OiAyMDBweDsKfQouaW1wb3dlckJveCAuc3RhdHVzIHsKICBkaXNwbGF5OiBub25lOwp9'
    }
  },
  methods: {
    openPersonal: function () {
      this.$router.push({ path: '/personal' })
    },
    openCandelAccount: function () {
      const _this = this
      if (_this.userInfo.Phone) {
        _this.getImageCode()
        _this.cancelAccountForm.PhoneNumber = _this.userInfo.Phone
        if (_this.userInfo.Phone.length >= 11) {
          _this.phone = _this.userInfo.Phone.substr(0, 3) + '****' + _this.userInfo.Phone.substr(7)
        }
      } else {
        _this.cancelAccountType = 2
      }
      _this.dialogAccountVerification = true
    },
    scanQRCode: function () {
      const _this = this
      _this.cancelAccountType = 2
    },
    phoneShortMessage: function () {
      const _this = this
      _this.cancelAccountType = 1
      _this.getImageCode()
    },
    getManagerUserDetail: function () {
      const _this = this
      _this.openLoading()
      _this.$api.userInfo.getManagerUserDetail().then(data => {
        _this.userInfo = data
        _this.countDown()
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getImageCode: function () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.$api.verificationCode.getImageCode().then(data => {
        _this.imageCode = 'data:image/png;base64,' + data.ImageCode
        _this.verificationPhoneCode.EncryptCode = data.EncryptCode
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    sendPhoneCode () {
      const _this = this
      const openLoading = _this.openLoading()
      if (_this.cancelAccountForm.PhoneNumber) {
        _this.$refs.cancelAccountForm.validateField('VerificationCode', validError => {
          if (!validError) {
            _this.verificationPhoneCode.InputCode = _this.cancelAccountForm.VerificationCode
            _this.verificationPhoneCode.PhoneNumber = _this.cancelAccountForm.PhoneNumber
            _this.$api.verificationCode.sendPhoneCode(_this.verificationPhoneCode).then(data => {
              // alert(data.Code)
              _this.cancelAccountForm.PhoneEncryptCode = data.EncryptCode
              _this.cancelAccountForm.PhoneEncryptExpireTime = data.EncryptExpireTime
              _this.cancelAccountForm.EncryptPhoneNumber = data.EncryptPhoneNumber
              _this.showPhoneCodeMessage = true
              setTimeout(function () {
                _this.showPhoneCodeMessage = false
              }, 60000)

              openLoading.close()
            }).catch(err => {
              openLoading.close()
              return err
            })
          } else {
            openLoading.close()
            return false
          }
        })
      } else {
        openLoading.close()
        return false
      }
    },
    submitCancelAccountForm: function (formName) {
      const _this = this
      this.$confirm('此操作将注销当前账户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        _this.$refs[formName].validate((valid) => {
          if (valid) {
            _this.cancelAccountForm.EncryptCode = _this.verificationPhoneCode.EncryptCode
            _this.$api.account.cancelAccountByPhone(_this.cancelAccountForm).then(data => {
              _this.$store.commit('REMOVE_ACCOUNT')
              openLoading.close()
              _this.$message({
                type: 'success',
                message: '已成功注销账户！'
              })
              this.$router.push({ name: 'login', params: { loginType: 'signIn' } })
            }).catch(err => {
              openLoading.close()
              return err
            })
          } else {
            openLoading.close()
            return false
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消注销',
          customClass: 'custom_message'
        })
      })
    },
    countDown: function () {
      const clock = window.setInterval(() => {
        this.countdown--
        if (this.countdown < 1) { // 当倒计时小于1时清除定时器
          window.clearInterval(clock)
          this.countdown = 15
          this.showCancelAccountBtn = true
        }
      }, 1000)
    },
    cancelAccountByWeChat () {
      const _this = this
      if (_this.$route.query.code) {
        _this.openLoading()
        _this.$api.account.cancelAccountByWeChat({ Code: _this.$route.query.code }).then(data => {
          _this.$message({
            showClose: true,
            type: 'success',
            message: '已成功注销账户！',
            customClass: 'custom_message'
          })
          _this.$store.commit('REMOVE_ACCOUNT')
          _this.openLoading().close()
          _this.$router.push({ name: 'login', params: { loginType: 'signIn' } })
        }).catch(err => {
          _this.getManagerUserDetail()
          return err
        })
      }
    }
  },
  watch: {
    '$route' (to, from) {
      const _this = this
      if (_this.$route.query.code) {
        _this.cancelAccountByWeChat()
      }
    }
  },
  created () {
    const _this = this
    if (_this.$route.query.code) {
      _this.cancelAccountByWeChat()
    } else {
      _this.getManagerUserDetail()
    }
  }
}
</script>

<style lang="less">
.cancel_account_head {
  width: 100%;
  flex-shrink: 0;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.cancel_account_head .title {
  padding: 50px 0px 50px 0px;
  font-size: 32px;
}
.cancel_account_head .wording {
  color: #444444;
  padding: 6px 0px 30px 0px;
  font-size: 16px;
}
.cancel_account_body {
  font-size: 12px;
  color: #888888;
  margin-top: 40px;
}
.cancel_account_title {
  font-size: 12px;
  color: #888888;
}
.cancel_account_content {
  font-size: 12px;
  color: #888888;
}
.cancel_account_content .item {
  margin-top: 20px;
}
.cancel_account_foot {
  text-align: center;
  margin-top: 40px;
}
@media screen and (max-width: 768px) {
  .cancelAccount_dialog {
    width: 96%;
  }
}
@media screen and (min-width: 768px) {
  .cancelAccount_dialog {
    width: 480px;
  }
}
.from_btn_box {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
}
.from_btn {
  width: 90px;
}
.more_sign_box {
  padding: 15px 0px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.cancel_code_box {
  padding: 10px 0 0 0px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.cancel_code {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
// 自定义二维码样式(以下样式需要生成为base64，href必须使用 text/css模式,生成的base64添加到"data:text/css;base64")
.impowerBox {
  text-align: left;
}
.impowerBox .title {
  display: none;
}
.impowerBox .status.status_browser {
  display: none;
}
.impowerBox .qrcode {
  margin-top: 0px;
  border: none;
  width: 200px;
  height: 200px;
}
.impowerBox .status {
  display: none;
}
</style>
